import * as yup from 'yup';

export const qrValidations = yup.object().shape({
    code1: yup
        .string()
        .matches(/^[0-9]+$/, 'Must be only digits')
        // eslint-disable-next-line no-magic-numbers
        .min(1, 'Must be exactly 5 digits')
        // eslint-disable-next-line no-magic-numbers
        .max(1, 'Must be exactly 5 digits')
        .required(),
    code2: yup
        .string()
        .matches(/^[0-9]+$/, 'Must be only digits')
        // eslint-disable-next-line no-magic-numbers
        .min(1, 'Must be exactly 5 digits')
        // eslint-disable-next-line no-magic-numbers
        .max(1, 'Must be exactly 5 digits')
        .required(),
    code3: yup
        .string()
        .matches(/^[0-9]+$/, 'Must be only digits')
        // eslint-disable-next-line no-magic-numbers
        .min(1, 'Must be exactly 5 digits')
        // eslint-disable-next-line no-magic-numbers
        .max(1, 'Must be exactly 5 digits')
        .required(),
    code4: yup
        .string()
        .matches(/^[0-9]+$/, 'Must be only digits')
        // eslint-disable-next-line no-magic-numbers
        .min(1, 'Must be exactly 5 digits')
        // eslint-disable-next-line no-magic-numbers
        .max(1, 'Must be exactly 5 digits')
        .required(),
    code5: yup
        .string()
        .matches(/^[0-9]+$/, 'Must be only digits')
        // eslint-disable-next-line no-magic-numbers
        .min(1, 'Must be exactly 5 digits')
        // eslint-disable-next-line no-magic-numbers
        .max(1, 'Must be exactly 5 digits')
        .required(),
    code6: yup
        .string()
        .matches(/^[0-9]+$/, 'Must be only digits')
        // eslint-disable-next-line no-magic-numbers
        .min(1, 'Must be exactly 5 digits')
        // eslint-disable-next-line no-magic-numbers
        .max(1, 'Must be exactly 5 digits')
        .required(),
});
